import { render, staticRenderFns } from "./RecommendSuggestion.vue?vue&type=template&id=4438accb&scoped=true&"
import script from "./RecommendSuggestion.vue?vue&type=script&lang=js&"
export * from "./RecommendSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./RecommendSuggestion.vue?vue&type=style&index=0&id=4438accb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4438accb",
  null
  
)

export default component.exports
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QSpinner,QField});
